import moment from 'moment';
import Vue from 'vue';
import { joinedValuesSeparator, dateTimeFormat } from '@/ts/DefaultTableConfigs';

export default class WaitingListsData {
    public id: number;
    public name: string;
    public email: string;
    public phone: string;
    public gender: string;
    public age: any;
    public educationTags: string;
    public interestsTags: string;
    public interestedFrom: string;
    public createdAt: string;
    public status: string;
    public projects: string;
    public types: string;
    public aboutMe: string;
    public applicationMotivation: string;
    public typeFormApplicationId: string;
    public address: string;
    public minSize: number;
    public maxSize: number;
    public minRent: number;
    public maxRent: number;
    public numberOfRooms: number;
    public optionAnswers: any;

    constructor(
        id: number,
        firstName: string,
        lastName: string,
        email: string,
        phone: string,
        gender: string,
        age: number,
        educationTags: string[],
        interestsTags: string[],
        status: string,
        interestedFrom: string,
        createdAt: string,
        projects: string[],
        types: string[],
        aboutMe: string,
        applicationMotivation: string,
        typeFormApplicationId: string,
        address: string,
        minSize?: number,
        maxSize?: number,
        minRent?: number,
        maxRent?: number,
        numberOfRooms?: number,
        optionAnswers?: any,
    ) {
        this.id                    = id;
        this.name                  = `${firstName} ${lastName}`;
        this.email                 = email;
        this.address               = address;
        this.phone                 = phone;
        this.gender                = gender !== null ? gender : '';
        this.age                   = age !== null ? age : '';
        this.educationTags         = educationTags.join(joinedValuesSeparator);
        this.interestsTags         = interestsTags.join(joinedValuesSeparator);
        this.status                = Vue.i18n.translate(`general.${status}`, status.charAt(0).toUpperCase() + status.slice(1));
        this.interestedFrom        = interestedFrom !== null ? interestedFrom : '';
        this.projects              = projects ? projects.join(joinedValuesSeparator) : '';
        this.types                 = types ? types.join(joinedValuesSeparator) : '';
        this.aboutMe               = aboutMe;
        this.applicationMotivation = applicationMotivation;
        this.typeFormApplicationId = typeFormApplicationId;
        this.createdAt             = createdAt !== null ? moment(createdAt).local().format(dateTimeFormat) : '';
        this.minSize               = minSize ? minSize : null;
        this.maxSize               = maxSize ? maxSize : null;
        this.minRent               = minRent ? minRent : null;
        this.maxRent               = maxRent ? maxRent : null;
        this.numberOfRooms         = numberOfRooms ? numberOfRooms : null;
        this.optionAnswers         = optionAnswers ? optionAnswers.sort((a: any, b: any)=> a.localeCompare(b)).join(joinedValuesSeparator) : null;
    }
}
